import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { inject } from '@angular/core';
import { AlertService } from '../../services/alert/alert.service';
import { AlertType } from '../../services/alert/alert.interface';
import { LoaderService } from '../../services/loader/loader.service';

declare let gtag: Function;

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const alertService = inject(AlertService);
  const loaderService = inject(LoaderService);

  return next(req).pipe(
    catchError((err: any) => {
      gtag('event', 'exception', {
        'description': err.message || err.toString(),
        'fatal': false
      });
      // if url of error contians register/applicant no show eeror
      if (err.url.includes('registration/applicant?')) {
        // refirecto to /register
        var cuurentUrl = window.location.href;
        if (cuurentUrl.includes('register') || cuurentUrl.includes('users')) {
          return throwError(() => err);
        } else {
          window.location.href = 'register';
          return throwError(() => err);
        }
      }
      if (err instanceof HttpErrorResponse && err.error) {
        if (err.error.code) {
          switch (err.error.code) {
            case 400:
              if (err.error.message) {
                alertService.setAlert({
                  message: err.error.message,
                  type: AlertType.Error,
                  dismissible: true,
                  dismissOnTimeout: 30000
                });
                loaderService.hide();
              }
              break;
            case 401:
              authService.logoutUser();
              alertService.setAlert({
                message: $localize`:@@Error.UserUnautorized:No tienes permisos para acceder a esta página. Por favor, inicia sesión.`,
                type: AlertType.Error,
                dismissible: true,
                dismissOnTimeout: 30000
              });
              window.location.href = '/login';
              loaderService.hide();
              break;
            case 500:
              alertService.setAlert({
                message: $localize`:@@Error.InternalServerError:Error interno del servidor. Se ha producido un problema inesperado en el servidor. Inténtelo de nuevo más tarde.`,
                type: AlertType.Error,
                dismissible: true,
                dismissOnTimeout: 30000
              });
              loaderService.hide();
              break;
          }
        } else if (err.status) {
          switch (err.status) {
            case 400:
              // if "Unexpected token 'I', "meesage to show" is not valid JSON"
              if (err.error.message.includes('Unexpected token')) {
                // get only message to show
                console.log(err.error.message);
                const message = err.error.message.split('"')[1];
                alertService.setAlert({
                  message: message,
                  type: AlertType.Error,
                  dismissible: true,
                  dismissOnTimeout: 30000
                });
                loaderService.hide();
              } else if (err.error.message) {
                alertService.setAlert({
                  message: err.error.message,
                  type: AlertType.Error,
                  dismissible: true,
                  dismissOnTimeout: 30000
                });
                loaderService.hide();
              }
              break;
          }
        }
      }
      return throwError(() => err);
    })
  );
};
